import type { PayReportRow, PayReportTeamMemberStatus } from './payReportTypes'

export const PAY_REPORT_DELETED_TM_SUPPORT_URL =
  'https://support.logmycare.co.uk/en/articles/10233510-how-does-deleting-a-service-user-or-staff-member-impact-your-rota'

export function resolvePayReportTeamMemberStatus(
  record: PayReportRow
): PayReportTeamMemberStatus {
  const tm = record.teamMember
  if (tm.deleted === true) {
    return 'deleted'
  }
  if (tm.active === false) {
    return 'inactive'
  }
  if (tm.deleted === false && tm.active === true) {
    return 'active'
  }
  if (record.teamMemberStatus != null) {
    return record.teamMemberStatus
  }
  return 'active'
}
